import { useFeatureGate } from '@/src/services/Statsig/useFeatureGate'
import { RewardsStatsig } from '../statsig'
import { Rewards } from './Rewards'
import RewardsLegacyScreen from './RewardsLegacy'
import { Loading } from '@/src/common/components/Loading'

export function RewardsScreenGate() {
  const isPointsLedgerUIEnabled = useFeatureGate(RewardsStatsig.FeatureGate.PointsLedgerUIEnabled)
  return isPointsLedgerUIEnabled.loadingStatus !== 'Ready' ? (
    <Loading />
  ) : isPointsLedgerUIEnabled.featureGate.value ? (
    <Rewards />
  ) : (
    <RewardsLegacyScreen />
  )
}

export const RewardsScreen = {
  name: 'rewards',
  Screen: RewardsScreenGate,
} as const
